import _ from 'lodash';
import React from 'react';

import WithPush from 'shared/HOCs/WithPush';

import { getUserCompanyName } from 'shared/utils/common';
import {
  redirectToUserCompany,
  getInfluencerPosition
} from 'shared/utils/influencer';

import styles from './styles.module.scss';

class InfluencerOccupationWithLink extends React.Component {
  redirectToCompany = () => {
    const { influencer, push } = this.props;

    redirectToUserCompany({ user: influencer, push });
  };

  render() {
    const { influencer, delimiter = ', ' } = this.props;
    const vendorName = getUserCompanyName(influencer);

    const position = getInfluencerPosition(influencer);
    const hasVendor = !_.isNil(vendorName);

    return (
      <React.Fragment>
        {position}
        {!_.isNil(position) && hasVendor && delimiter}
        <span onClick={this.redirectToCompany} className={styles.link}>
          {vendorName}
        </span>
      </React.Fragment>
    );
  }
}

export default WithPush(InfluencerOccupationWithLink);
